import React, { useEffect, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const openInvoice = async (id) => {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.get(`/invoices/${id}/html`, { responseType: "text" });
    w.document.open(); w.document.write(data); w.document.close();
  } catch { w && w.close(); toast.error("تعذّر فتح الفاتورة"); }
};

export const InvoicesList = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/invoices").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return <div className="flex justify-center py-4"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>;
  return (
    <div className="glass rounded-2xl p-5 border border-border" data-testid="invoices-card">
      <div className="font-bold flex items-center gap-2 mb-3"><FileText className="w-4 h-4 text-primary" /> فواتيري</div>
      {items.length === 0 ? <p className="text-sm text-muted-foreground">لا توجد فواتير بعد — تصلك الفاتورة على إيميلك وتظهر هنا بعد كل عملية دفع.</p> : (
        <div className="space-y-2">
          {items.map((i) => (
            <div key={i.id} className="flex items-center justify-between gap-3 rounded-xl bg-secondary px-4 py-2.5" data-testid={`invoice-${i.number}`}>
              <div className="min-w-0">
                <div className="text-sm font-bold">{i.number}{i.test && <span className="text-[10px] text-accent mr-2">تجريبية</span>}</div>
                <div className="text-xs text-muted-foreground truncate">{i.items?.[0]?.description} · {i.issued_at?.slice(0, 10)}</div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-sm font-bold">{i.total} ريال{i.vat_amount ? <span className="block text-[10px] font-normal text-muted-foreground" data-testid={`invoice-vat-${i.number}`}>منها ضريبة {i.vat_amount} ريال</span> : null}</span>
                <Button size="sm" variant="outline" className="border-border" onClick={() => openInvoice(i.id)} data-testid={`invoice-open-${i.number}`}>عرض / طباعة</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
